<template>
	<div class="MAM_queryList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="queryForm" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="queryForm.channel_mer_no" placeholder="请输入商户编号"></el-input>
				</el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="queryForm.terminal_sn" placeholder="请输入sn"></el-input>
                </el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(queryForm)">查询</el-button>
                    <el-button size="medium" type="primary"  style="font-size: 12px;"
                    	@click="onApply()">提现记录</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">
				<el-table-column  min-width="150" header-align="center" align="center" prop="channel_mer_no" label="商户编码"></el-table-column>
                <el-table-column  min-width="150" header-align="center" align="center" prop="ch_merchant_name" label="商户名称"></el-table-column>
                <el-table-column  min-width="150" header-align="center" align="center" prop="mer_phone" label="商户手机号"></el-table-column>
                <el-table-column min-width="150"   header-align="center" align="center" prop="money" label="可提现余额(元)">
                	<template slot-scope="scope">
                		<span style="color:#F56C6C">{{scope.row.can_withdraw_money}}</span>
                	</template>
                </el-table-column>
				<el-table-column  min-width="180"  header-align="center" align="center" prop="settle_card_no" label="结算卡信息"></el-table-column>
				<el-table-column  min-width="150" header-align="center" align="center" prop="bank_name" label="开户总行"></el-table-column>
				<el-table-column min-width="200"   header-align="center" align="center" prop="bank_branch" label="支行信息"></el-table-column>
				<el-table-column  min-width="180" header-align="center" align="center" prop="create_time" label="提现时间"></el-table-column>
				<el-table-column min-width="100"  header-align="center" align="center" fixed="right" label="操作"  >
					<template  slot-scope="scope">
						<el-button @click="shenClick(scope.row)" type="text" size="small">提现</el-button>
					</template>
					
				</el-table-column>
				
			</el-table>
		</el-card>
		
		<el-dialog width="30%" title="温馨提示" :visible.sync="applyState" class="dialog">
			<span>当前商户钱包可提现余额￥{{cellItem.can_withdraw_money}}，确认提现？</span>
			<div slot="footer" class="dialog-footer">
			    <el-button :loading="downLoading"   type="primary"  @click="chuPayClick">确定</el-button>
			    <el-button   @click="applyState = false">取 消</el-button>
			</div>
		  
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "ysBalanceCashDown",
		data() {
			return {
				queryForm: {
					channel_mer_no:''
				},
				stockTable: { //列表
					list: [],
				},
				loading: false,
				downLoading: false, //导出loading
                applyState:false,
                cellItem:{}
			}
		},
		methods: {
            onApply(){
                this.$router.push({ path: '/balanceCashDownRecord'});
            },
            shenClick(item){
            	this.cellItem = item
            	this.applyState = true
            },
			// 出款
			chuPayClick(){
				let params = {
					channel_mer_no:this.cellItem.channel_mer_no
				}
				this.downLoading = true;
				this.$api.post("mc_with_draw/doMcWithDrawInfo", params, res => {
					if (res.code == 0) {
						this.$message({
						    message: '出款成功!',
							type:'success'
						});
					}else {
						this.$message({
						    message: res.msg
						});
					}
					this.downLoading = false;
                    this.applyState = false
					this.getData(queryForm);
				})
				
			},
			onSearch(queryForm) {
				// 表单提交
				this.getData(queryForm);
			},
			getData(params) {
				this.$api.post("mc_with_draw/getMcWithDrawInfo", params, res => {
					if (res.code == 0) {
						let data = res.data;
						this.stockTable.list = data.list;
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false;
				})
			}
		}
	};
</script>

<style lang="scss" scope>
	.MAM_queryList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
	.dialogDes {
		height: 30px;
		line-height: 30px;
	}
</style>